const AtIcon = ({ color }: any) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.99967 10.6673C9.47243 10.6673 10.6663 9.47341 10.6663 8.00065C10.6663 6.52789 9.47243 5.33398 7.99967 5.33398C6.52692 5.33398 5.33301 6.52789 5.33301 8.00065C5.33301 9.47341 6.52692 10.6673 7.99967 10.6673Z'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.6663 5.33357V8.6669C10.6663 9.19734 10.8771 9.70605 11.2521 10.0811C11.6272 10.4562 12.1359 10.6669 12.6663 10.6669C13.1968 10.6669 13.7055 10.4562 14.0806 10.0811C14.4556 9.70605 14.6663 9.19734 14.6663 8.6669V8.00024C14.6663 6.49559 14.1572 5.03522 13.2219 3.85659C12.2866 2.67796 10.98 1.85039 9.51477 1.50844C8.0495 1.16648 6.51164 1.33027 5.15125 1.97315C3.79086 2.61603 2.68795 3.70021 2.02185 5.04939C1.35576 6.39856 1.16566 7.9334 1.48246 9.40431C1.79926 10.8752 2.60433 12.1957 3.76677 13.1511C4.9292 14.1064 6.38064 14.6405 7.88506 14.6663C9.38948 14.6922 10.8584 14.2084 12.053 13.2936'
        stroke='white'
        strokeWidth='1.3'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default AtIcon
